/**
 * HybridFileHandlerNode.tsx — Canvas node chip
 * Uses BaseNodeUI exactly like RelaySourceNode, FileSourceNode etc.
 */
import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { FolderOpen } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

const SOURCE_LABELS: Record<string, string> = {
  platform_upload: 'File Upload',
  aws_s3:          'AWS S3',
  azure_blob:      'Azure Blob',
  sharepoint:      'SharePoint',
  google_drive:    'Google Drive',
  onedrive:        'OneDrive',
};

const HybridFileHandlerNode = ({ data, selected }: NodeProps) => (
    <BaseNodeUI
        title={data.label || 'Hybrid File Handler'}
        icon={FolderOpen}
        colorClass=""
        bgClass="bg-gradient-to-br from-purple-500 to-violet-700"
        selected={selected}
        executionStatus={data?.executionStatus}
        isRunning={data?.executionStatus === 'Running'}
        isSource={true}
        isTarget={true}
    >
        {data?.sourceType && (
            <span className="text-[9px] font-medium text-purple-600 bg-purple-50 px-1.5 py-0.5 rounded whitespace-nowrap">
                {SOURCE_LABELS[data.sourceType] || data.sourceType}
            </span>
        )}
    </BaseNodeUI>
);

export default memo(HybridFileHandlerNode);
